import { Trip } from "@fairfleet/geotab";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { getTripOdometerKm } from "../utils/getTripOdometerKm";
import { useFormattedDistance } from "@/hooks/metrics/useFormattedDistance";

interface Props {
  props: GridRenderCellParams<Trip>;
  variant: "start" | "end";
}

export function OdometerCell({ props, variant }: Props) {
  const km = getTripOdometerKm(props.row, variant);
  const formatted = useFormattedDistance(km ?? 0);

  return <>{km == null ? "" : formatted}</>;
}
